export const adminEn = {
    'admin.language.selector': 'Interface language',
    'admin.language.el': 'Ελληνικά',
    'admin.language.en': 'English',
    'nav.overview': 'Overview',
    'nav.sites': 'Websites',
    'nav.knowledge': 'Knowledge base',
    'nav.conversations': 'Conversations',
    'nav.contacts': 'Contacts',
    'nav.usage': 'Usage & billing',
    'nav.members': 'Members',
    'nav.audit': 'Audit',
    'nav.settings': 'Settings',
    'nav.platform': 'Overview',
    'nav.tenants': 'Customers',
    'nav.plans': 'Plans',
    'nav.billing': 'Invoicing',
    'nav.costs': 'OpenAI cost',
    'nav.platformSettings': 'Platform settings',
    'nav.setup': 'Setup guide',
    'nav.system': 'System',
    'nav.systemStatus': 'Status',
    'shell.platformManage': 'Platform management',
    'shell.clientDashboard': 'Customer dashboard',
    'shell.platformSection': 'Platform',
    'shell.organization': 'Organization',
    'shell.client': 'Customer',
    'shell.systemSection': 'System',
    'shell.pickTenant': 'Select a customer from the top menu to view their data.',
    'shell.tenantLabel': 'Customer',
    'shell.noneTenant': '— None —',
    'shell.suspended': 'suspended',
    'shell.platformAdmin': 'Platform admin',
    'shell.tenantAdmin': 'Admin',
    'shell.viewer': 'View only',
    'shell.logout': 'Sign out',
    'shell.login': 'Sign in',
    'shell.loadingSession': 'Loading session…',
    'shell.version': 'Version {version}',
    'shell.privateAuth': 'Private management area. Access is by invitation only.',
    'shell.mainNav': 'Main navigation',
    'shell.group.platform': 'Platform',
    'shell.group.organization': 'Organization',
    'shell.group.system': 'System',
    'shell.noAccess.title': 'This account does not belong to any customer.',
    'shell.noAccess.hint': 'Ask your organization admin for an invitation.',
    'shell.notFound': 'Page not found.',
    'auth.login.title': 'Sign in to {product}',
    'auth.login.submit': 'Sign in',
    'auth.login.submitting': 'Signing in…',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.passwordPlaceholder': 'Enter your password',
    'auth.showPassword': 'Show password',
    'auth.hidePassword': 'Hide password',
    'auth.forgot': 'Forgot password',
    'auth.invalidCredentials': 'Those credentials were not accepted.',
    'auth.changePassword.failed': 'Password was not changed. Check the current password and the new password rules.',
    'auth.secureAccess': 'Secure access',
    'common.save': 'Save',
    'common.saving': 'Saving…',
    'common.cancel': 'Cancel',
    'common.close': 'Close',
    'common.retry': 'Retry',
    'common.loading': 'Loading…',
    'common.error': 'Something went wrong.',
    'common.back': 'Back',
    'common.continue': 'Continue',
    'common.skip': 'Skip',
    'common.later': 'Later',
    'common.create': 'Create',
    'common.delete': 'Delete',
    'common.activate': 'Activate',
    'common.reject': 'Reject',
    'common.search': 'Search',
    'common.all': 'All',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.actions': 'Actions',
    'setup.progress': 'Step {current} of {total}',
    'setup.welcome.title': 'Let’s set up the platform',
    'setup.welcome.body': 'This guide configures what is needed for the chatbot to answer on one website.',
    'setup.step.welcome': 'Welcome',
    'setup.step.brand': 'Appearance',
    'setup.step.ai': 'AI provider',
    'setup.step.mail': 'Email',
    'setup.step.customer': 'Customer',
    'setup.step.site': 'Website',
    'setup.step.knowledge': 'Knowledge',
    'setup.step.connect': 'WordPress',
    'setup.step.invite': 'Invite',
    'setup.step.done': 'Done',
    'setup.connect.steps': '1) Download the plugin. 2) Paste the API URL and pairing code. 3) Select pages and sync.',
    'setup.validation.required': 'Fill in the required fields before continuing.',
    'knowledge.title': 'Knowledge base',
    'knowledge.status.draft': 'Draft',
    'knowledge.status.processing': 'Processing',
    'knowledge.status.active': 'Active',
    'knowledge.status.failed': 'Failed',
    'knowledge.status.inactive': 'Inactive',
    'knowledge.retry': 'Retry processing',
    'knowledge.errorReason': 'Reason',
    'knowledge.ingestionProgress': 'Processing content…',
    'knowledge.needsReview': 'Needs review',
    'knowledge.syncRequested': 'Request recorded. The plugin will send the pages selected in WordPress.',
    'sync.lastRun': 'Last sync',
    'sync.nextScheduled': 'Next scheduled',
    'sync.progress': 'Sync progress',
    'sync.failedItems': 'Failed items',
    'sync.retryItem': 'Retry',
    'sync.skipItem': 'Skip',
    'sync.request': 'Request sync',
    'sync.noRuns': 'No sync runs yet.',
    'dashboard.quotaAlert80': 'You have reached 80% of the monthly answer quota.',
    'dashboard.quotaAlert100': 'The monthly answer quota is exhausted.',
    'dashboard.provider': 'AI provider',
    'dashboard.provider.mock': 'Mock',
    'dashboard.provider.openai': 'OpenAI',
    'dashboard.provider.mockHint': 'Answers are local; there is no provider charge.',
    'dashboard.queue': 'Job queue',
    'dashboard.syncHealth': 'Sync health',
    'dashboard.healthy': 'Healthy',
    'dashboard.degraded': 'Attention',
    'billing.status.open': 'Unpaid',
    'billing.status.partial': 'Partial payment',
    'billing.status.overdue': 'Overdue',
    'billing.status.paid': 'Paid',
    'billing.status.void': 'Void',
    'billing.balance': 'Balance',
    'billing.paymentHistory': 'Payment history',
    'billing.downloadLater': 'Invoice PDF download will be added in a later release.',
    'widget.offline.title': 'Service unavailable',
    'widget.offline.retry': 'Retry connection',
};
//# sourceMappingURL=admin-en.js.map